<template>
  <CustomModal
    noPadding
    class="display-video"
    :is-modal-open="isOpen"
    @toggleModal="closeModal"
    @onClickAway="closeModal"
    :overlay="'dark'"
    :with-header="true"
    :with-footer="true"
    :custom-classes="'tw:w-screen tw:h-screen tw:md:h-auto tw:md:max-w-[768px] tw:md:w-[768px] tw:md:rounded-md tw:rounded-none'"
  >
    <template #modalHeader>
      <p class="tw:text-xl tw:text-gray-700">
        {{ $t(title) }}
      </p>
    </template>

    <div class="tw:w-full tw:flex">
      <div class="tw:p-8 tw:flex tw:items-center tw:w-full">
        <div class="tw:relative tw:w-full tw:pb-[65.25%]">
          <div
            data-testid="rate-connect-video-player"
            ref="playerContainerRef"
            class="tw:absolute tw:top-0 tw:left-0 tw:w-full tw:h-full"
          ></div>
        </div>
      </div>
    </div>

    <template #modalFooter>
      <div class="tw:flex tw:w-full tw:justify-end">
        <MainButton @click="closeModal()">{{ $t('close') }}</MainButton>
      </div>
    </template>
  </CustomModal>
</template>

<script setup>
import { computed, onBeforeUnmount, ref, watch } from 'vue'

import Player from '@vimeo/player'
import CustomModal from '@/components/base/CustomModal.vue'
import MainButton from '@/components/base/buttons/MainButton.vue'

const props = defineProps({
  isOpen: Boolean,
  title: String,
})

const emit = defineEmits(['closeModal'])

const closeModal = () => {
  emit('closeModal')
}

const playerContainerRef = ref(null)

let player = null

const videoUrl = computed(() => `https://player.vimeo.com/video/1135690833?h=4defb64a74`)

const initPlayer = () => {
  if (!playerContainerRef.value) return

  if (player) {
    player.destroy()
    player = null
  }

  player = new Player(playerContainerRef.value, {
    url: videoUrl.value,
    autoplay: true,
    muted: true,
    controls: true,
    responsive: true,
    autopause: false,
    badge: false,
  })
}

watch(
  () => props.isOpen,
  isOpen => {
    if (isOpen) {
      setTimeout(() => {
        if (!props.isOpen) return
        initPlayer()
      }, 100)
    } else {
      if (player) {
        player.destroy()
        player = null
      }
    }
  }
)

onBeforeUnmount(() => {
  if (player) {
    player.destroy()
    player = null
  }
})
</script>
